import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pie-chart-ghost-card',
  templateUrl: './pie-chart-ghost-card.component.html',
  styleUrls: ['./pie-chart-ghost-card.component.css']
})
export class PieChartGhostCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-ghost-card-module/pie-chart-ghost-card/pie-chart-ghost-card.component.ts